module.exports = __webpack_public_path__ + "img/NudgPay.a3b3582d.png";